<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item :label="$t('rolemanage.Name')">
        <el-input :placeholder="$t('rolemanage.placeholder')" v-model="filter.rolename" clearable></el-input>
      </el-form-item>
      <el-form-item :label="$t('rolemanage.Status')">
        <el-select v-model="filter.status" class="input-mini">
          <el-option :label="$t('rolemanage.Status1')" value=""></el-option>
          <el-option :label="$t('rolemanage.Status4')" value="1"></el-option>
          <el-option :label="$t('rolemanage.Status3')" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <el-button icon="el-icon-plus" type="success" @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column :label="$t('rolemanage.serial')" type="index" width="80"></el-table-column>
      <el-table-column :label="$t('rolemanage.Name')" prop="Name"></el-table-column>
      <el-table-column label="类型" prop="is_merchant">
        <template slot-scope="{ row }">
          <el-tag type="info" effect="plain" v-if="row.is_merchant">商户角色</el-tag>
          <el-tag type="success" effect="plain" v-else>平台角色</el-tag>
        </template>
      </el-table-column>
      <el-table-column :label="$t('rolemanage.Status')" prop="Status">
        <template slot-scope="{ row }">
          <el-tag type="success" effect="plain" v-if="row.Status">启用</el-tag>
          <el-tag type="danger" effect="plain" v-else>禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column :label="$t('rolemanage.CreateTime')" sortable prop="CreateTime"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="240px">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onUpdate(row)" v-permision_tjtf="'edit'">编辑</el-button>
          <el-button type="text" @click="onAssignMenu(row)" v-permision_tjtf="'menu_allocation'">{{ $t("rolemanage.allocation2") }}</el-button>
          <el-button type="text" @click="onDelete(row)" v-permision_tjtf="'delete'">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 新增or修改角色 -->
    <el-dialog :visible.sync="visible.editRole" :title="isUpdate ? $t('rolemanage.editortitle') : $t('rolemanage.appendtitle')" width="800px">
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form label-position="right" label-width="130px" :model="form" :rules="formRules" ref="roleForm">
            <el-form-item :label="$t('rolemanage.Name')" prop="roleName">
              <el-input :placeholder="$t('rolemanage.placeholder')" v-model="form.roleName" />
            </el-form-item>
            <el-form-item :label="$t('rolemanage.roleDesc')" prop="roleDesc">
              <el-input :placeholder="$t('rolemanage.placeholder1')" v-model="form.roleDesc" type="textarea" />
            </el-form-item>
            <el-form-item label="类型">
              <el-switch v-model="form.is_merchant" active-text="商户角色" inactive-text="平台角色" />
            </el-form-item>
            <el-form-item label="是否禁用">
              <el-switch v-model="form.Status" active-text="启用" inactive-text="禁用" />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="visible.editRole = false">{{ $t("rolemanage.cancelbtn") }}</el-button>
        <el-button type="primary" @click="submitRole">{{ $t("rolemanage.confirmbtn") }}</el-button>
      </span>
    </el-dialog>

    <el-drawer :visible.sync="menusList" size="50%" :title="$t('rolemanage.allocation1') + '【' + rowName + '】' + $t('rolemanage.allocation2')">
      <div class="p-20">
        <el-tree ref="menuTree" v-loading="treeLoading" :data="treeData" show-checkbox node-key="id" default-expand-all :expand-on-click-node="false" :check-strictly="isCheck" :default-checked-keys="checkedMenuIds">
          <template #default="{ node, data }">
            <div class="custom-tree-node">
              <span>{{ node.label }}</span>
              <span class="btnPermissions">
                <label v-for="btn in data.btnPermissions" @click="onBtnClick(node, btn)" :class="{ 'has-selected': btn.is_sel }" :key="btn.name" :label="btn.permission" class="btn-item">
                  {{ btn.name }}
                </label>
              </span>
            </div>
          </template>
        </el-tree>
        <div class="drawer-btn">
          <el-button @click="menusList = false">{{ $t("rolemanage.cancelbtn") }}</el-button>
          <el-button type="primary" @click="onSubmitMenus">{{ $t("rolemanage.confirmbtn") }}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import { addRole, deleteRole, updateRole, getRole, getMenusTree, getMenuByRoleId, assginMenus } from "@/api/user"
export default {
  name: "RoleManager",
  mixins: [pageMixin],
  components: { fileUpload },
  data() {
    const checkFun = (rule, value, callback) => {
      if (!this.form.relateId) {
        if (!value) {
          return callback(new Error(`${this.$t("rolemanage.placeholder2")}`))
        }
      }
      callback()
    }
    return {
      visible: {
        editRole: false
      },
      filter: {
        rolename: "",
        status: ""
      },
      tableData: [],
      menusList: false,
      treeData: [],
      treeLoading: false,
      form: {
        roleName: "",
        roleDesc: "",
        relateId: "",
        is_merchant: false,
        Status: true
      },
      formRules: {},
      loading: false,
      isUpdate: true,
      rid: "", //角色id
      rowName: "",
      checkedMenuIds: [],
      isCheck: false
    }
  },
  created() {
    this.formRules = {
      roleName: [{ required: true, message: this.$t("rolemanage.placeholder"), trigger: "blur" }],
      relateId: [{ required: true, message: "请选择所属商户/平台", trigger: "change" }]
    }
    this.getData()
  },
  methods: {
    onBtnClick(node, btn) {
      btn.is_sel = !btn.is_sel
      node.checked = true
      //console.log("node", node, "btn", btn)
    },
    fileChange(fileList, field) {
      this.form[field] = fileList
    },
    getSelectBtn() {
      var roleBtns = new Array()
      this.treeData.forEach((item) => {
        this.getSelectBtnFromChildren(roleBtns, item.children)
      })
      return roleBtns
    },
    getSelectBtnFromChildren(roleBtns, children) {
      if (children && children.length > 0) {
        children.forEach((child) => {
          if (child.children && child.children.length > 0) {
            this.getSelectBtnFromChildren(roleBtns, child.children)
          }
          if (child.btnPermissions && child.btnPermissions.length > 0) {
            var btns = new Array()
            child.btnPermissions.forEach((item) => {
              if (item.is_sel) {
                btns.push(item.permission)
              }
            })
            if (btns.length > 0) roleBtns.push({ module: child.id, btns: btns })
          }
        })
      }
    },

    onSubmitMenus() {
      let checkedIds = []
      this.$refs.menuTree.getCheckedKeys().forEach((d) => {
        checkedIds.push(d)
      })

      this.$refs.menuTree.getHalfCheckedKeys().forEach((d) => {
        checkedIds.push(d)
      })
      var roleBtns = this.getSelectBtn()

      const loading = this.$loading()
      assginMenus({
        Key: "RoleModule",
        firstId: this.rid, //角色id
        SecondId: JSON.stringify(checkedIds), //选中的模块id
        SecondBtns: JSON.stringify(roleBtns)
      })
        .then((res) => {
          this.$message.success(`${this.$t("rolemanage.assginsuccess")}`)
        })
        .finally(() => {
          loading.close()
        })
    },
    onAssignMenu(row) {
      this.menusList = true
      this.rid = row.Id
      this.rowName = row.Name
      this.treeLoading = true

      let apis = [getMenuByRoleId({ Id: row.Id }), getMenusTree()]
      Promise.all(apis)
        .then((res) => {
          this.isCheck = true
          //搞个延迟，后台数据给data区域里赋值需要时间
          this.$nextTick(() => {
            let menus = res[0].dt
            let menusIds = menus.map((item) => item.Id)
            this.checkedMenuIds = menusIds
            this.treeData = res[1].dt
            //再打开级联效果
            this.isCheck = false
            this.setSelectBtn(menus)
          })
        })
        .finally(() => {
          this.treeLoading = false
        })
    },
    setSelectBtn(allRoleBtns) {
      console.log("ssssssssssssssallRoleBtns", allRoleBtns)
      this.treeData.forEach((item) => {
        this.setSelectBtnFromChildren(allRoleBtns, item.children)
      })
    },
    setSelectBtnFromChildren(allRoleBtns, children) {
      if (children && children.length > 0) {
        children.forEach((child) => {
          if (child.children && child.children.length > 0) {
            this.setSelectBtnFromChildren(allRoleBtns, child.children)
          }
          var mItem = allRoleBtns.find((item) => item.Id == child.id)
          if (mItem && mItem.btnPermissions) {
            var rolebtns = JSON.parse(mItem.btnPermissions)

            //console.log("ssssssssssssss2", rolebtns)
            if (rolebtns && rolebtns.length > 0) {
              child.btnPermissions.forEach((btn) => {
                var find = rolebtns.find((item) => item == btn.permission)
                if (find) {
                  btn.is_sel = true
                }
              })
            }
          }
        })
      }
    },
    onUpdate(row) {
      this.visible.editRole = true
      this.isUpdate = true
      this.form.roleName = row.Name
      this.form.roleDesc = row.roledesc
      this.form.relateId = row.Group_id
      this.form.is_merchant = row.is_merchant
      this.form.Status = row.Status
      this.rid = row.Id
    },
    onDelete(row) {
      this.$confirm(`${this.$t("rolemanage.removetitle")}`, `${this.$t("rolemanage.tic")}`, {
        type: "warning"
      })
        .then(() => {
          deleteRole({
            Id: row.Id
          }).then((res) => {
            this.$message.success(`${this.$t("publics.deletesuccessful")}`)
            this.toFilter()
          })
        })
        .catch(() => {})
    },
    getData() {
      this.loading = true

      let rules = [];
      if(this.filter.rolename){
        rules.push({ field: "Name", op: "like", value: this.filter.rolename })
      }
      if(this.filter.status && this.filter.status.trim().length > 0){
        rules.push({ field: "Status", op: "equal", value: this.filter.status })
      }
      getRole({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        where: JSON.stringify({
          rules: rules,
          op: "and"
        })
      })
        .then((res) => {
          this.tableData = res.dt
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    onAdd() {
      this.visible.editRole = true
      this.isUpdate = false
      this.form = this.$options.data().form
    },
    submitRole() {
      this.$refs.roleForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading()
          const reqData = {
            ID: this.rid || null,
            Name: this.form.roleName,
            roledesc: this.form.roleDesc,
            Group_id: this.form.relateId,
            is_merchant: this.form.is_merchant,
            Status: this.form.Status
          }
          if (this.isUpdate) {
            updateRole(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.modifiedsuccessful")}`)
                this.visible.editRole = false
                this.toFilter()
              })
              .finally(() => {
                loading.close()
              })
          } else {
            addRole(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.addedsuccessful")}`)
                this.visible.editRole = false
                this.toFilter()
              })
              .finally(() => {
                loading.close()
              })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}

.drawer-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
}
.btnPermissions {
  padding-left: 20px;
}
.btn-item {
  margin-right: 10px;
  padding: 2px 8px;
  border-radius: 2px;
  font-size: 12px;
  font-weight: normal;
  cursor: pointer;
  border: 1px solid #dcdfe6;
}
.has-selected {
  border: 1px solid #409eff;
  background-color: #409eff;
  color: #fff;
}
</style>
